import React from 'react'
import Button from '../../../../../components/common/button/Button'
import { InfoCircleOutlined } from '@ant-design/icons'
import Paragraph from 'antd/es/typography/Paragraph'
import Popover from '../../../../../components/common/popover/Popover'

const InstructionsButton = () => {
    const content = (
        <>
            <Paragraph>Shortcuts</Paragraph>
            <Paragraph>
                <code>Arrow left</code>/<code>Arrow right</code> - move to the previous/next submission.
            </Paragraph>
            <Paragraph>
                <code>alt</code> + <code>Enter</code> - approve the category for focused question.
            </Paragraph>
            <Paragraph>
                <code>ctrl</code> + <code>alt</code> + <code>Arrow up</code>/<code>Arrow down</code> - move question
                focus.
            </Paragraph>
        </>
    )

    return (
        <Popover content={content} title='Instructions' trigger='click' overlayStyle={{ maxWidth: 400 }}>
            <Button shape='circle' type='text' icon={<InfoCircleOutlined aria-hidden='true' />} title='Instructions' />
        </Popover>
    )
}

export default InstructionsButton
